/**
 * TW FAQ — scroll to section and open a target accordion by anchor id.
 */
(function () {
  const HEADER_BUFFER = 16;
  const FALLBACK_HEADER_OFFSET = 80;
  const RETRY_DELAYS_MS = [0, 100, 500];

  function getHeaderOffset() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    const parsed = parseFloat(raw);
    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed + HEADER_BUFFER;
    }
    return FALLBACK_HEADER_OFFSET;
  }

  function findFaqSection() {
    const scrollTarget = document.querySelector('[data-tw-faq-scroll-target]');
    if (scrollTarget) {
      return scrollTarget.closest('.shopify-section') || scrollTarget;
    }

    const faqRoot = document.querySelector('[data-tw-faq]');
    if (faqRoot) {
      return faqRoot.closest('.shopify-section') || faqRoot;
    }

    return null;
  }

  function findFaqItem(anchorId) {
    if (!anchorId) return null;
    const normalized = anchorId.trim().toLowerCase();
    return (
      document.querySelector(`[data-tw-faq-anchor="${normalized}"]`) ||
      document.getElementById(`tw-faq-${normalized}`)
    );
  }

  function scrollToTarget(target) {
    if (!target) return false;
    const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function openFaqItem(item) {
    if (!item || item.tagName !== 'DETAILS') return false;

    const list = item.closest('.tw-faq__list');
    if (list) {
      list.querySelectorAll('.tw-faq__item[open]').forEach((openItem) => {
        if (openItem !== item) openItem.removeAttribute('open');
      });
    }

    item.setAttribute('open', '');
    return true;
  }

  function openFaqAnchor(anchorId) {
    const item = findFaqItem(anchorId);
    const section = findFaqSection();
    if (!section && !item) return false;

    if (item) {
      openFaqItem(item);
      scrollToTarget(section || item);
      return true;
    }

    return scrollToTarget(section);
  }

  function updateHash(anchorId) {
    const hash = `tw-faq-${anchorId}`;
    if (history.replaceState) {
      history.replaceState(null, '', `#${hash}`);
    } else {
      window.location.hash = hash;
    }
  }

  function parseHashAnchor() {
    const hash = window.location.hash.replace(/^#/, '');
    if (!hash || !hash.startsWith('tw-faq-')) return null;
    return hash.slice('tw-faq-'.length);
  }

  function runWithRetry(anchorId, onComplete) {
    let completed = false;

    RETRY_DELAYS_MS.forEach((delay) => {
      setTimeout(() => {
        if (completed) return;
        if (openFaqAnchor(anchorId)) {
          completed = true;
          if (onComplete) onComplete();
        }
      }, delay);
    });
  }

  function handleHashOnLoad() {
    const anchor = parseHashAnchor();
    if (!anchor) return;
    runWithRetry(anchor);
  }

  function onClick(event) {
    const trigger = event.target.closest('[data-tw-faq-open]');
    if (!trigger) return;

    const anchor = trigger.dataset.twFaqOpen;
    if (!anchor) return;

    event.preventDefault();
    runWithRetry(anchor, () => updateHash(anchor));
  }

  document.addEventListener('click', onClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleHashOnLoad);
  } else {
    handleHashOnLoad();
  }

  window.addEventListener('hashchange', handleHashOnLoad);
})();
